import { IGetMessengerConversationsRequest } from "@faire/web-api--source/indigofair/data/IGetMessengerConversationsRequest";

import {
  ConversationModel,
  isConversationUnRead,
  isConversationStarredByBrand,
} from "./ConversationModel";

export const FILTER_SUPPORT_CONVERSATION = true;

export interface MainStreamFetchState {
  isFirstFetch: boolean;
  nextRequest?: IGetMessengerConversationsRequest;

  /**
   * HACK!!! These are used to compare previous and current responses on the main stream so we know if we are done fetching
   */
  lastMainStreamConversationRequestTokens?: (string | undefined)[];

  conversationByConversationToken: Map<string, ConversationModel>;

  // TODO: This should be removed once API v3 is stable (as we'll rely on brand/retailer tokens)
  conversationByUserToken: Map<string, ConversationModel>;

  conversationByBrandToken: Map<string, ConversationModel>;

  conversationByRetailerToken: Map<string, ConversationModel>;
}

export const createMainStreamFetchState = (): MainStreamFetchState => ({
  isFirstFetch: true,
  conversationByConversationToken: new Map(),
  conversationByUserToken: new Map(),
  conversationByBrandToken: new Map(),
  conversationByRetailerToken: new Map(),
});

export const removeReadConversations = (
  state: MainStreamFetchState
): MainStreamFetchState => {
  return {
    ...state,
    conversationByUserToken: new Map(
      [...state.conversationByUserToken].filter(([_, conversation]) =>
        isConversationUnRead(conversation)
      )
    ),
    conversationByBrandToken: new Map(
      [...state.conversationByBrandToken].filter(([_, conversation]) =>
        isConversationUnRead(conversation)
      )
    ),
    conversationByRetailerToken: new Map(
      [...state.conversationByRetailerToken].filter(([_, conversation]) =>
        isConversationUnRead(conversation)
      )
    ),
    conversationByConversationToken: new Map(
      [...state.conversationByConversationToken].filter(([_, conversation]) =>
        isConversationUnRead(conversation)
      )
    ),
  };
};

export const removeNonStarredByBrandConversations = (
  state: MainStreamFetchState
): MainStreamFetchState => {
  return {
    ...state,
    conversationByUserToken: new Map(
      [...state.conversationByUserToken].filter(([_, conversation]) =>
        isConversationStarredByBrand(conversation)
      )
    ),
    conversationByBrandToken: new Map(
      [...state.conversationByBrandToken].filter(([_, conversation]) =>
        isConversationStarredByBrand(conversation)
      )
    ),
    conversationByRetailerToken: new Map(
      [...state.conversationByRetailerToken].filter(([_, conversation]) =>
        isConversationStarredByBrand(conversation)
      )
    ),
    conversationByConversationToken: new Map(
      [...state.conversationByConversationToken].filter(([_, conversation]) =>
        isConversationStarredByBrand(conversation)
      )
    ),
  };
};

export const setIsFirstFetch = (
  state: MainStreamFetchState,
  isFirstFetch: boolean
): MainStreamFetchState => ({
  ...state,
  isFirstFetch,
});

export const setNextRequest = (
  state: MainStreamFetchState,
  nextRequest?: IGetMessengerConversationsRequest
): MainStreamFetchState => ({
  ...state,
  nextRequest,
});

export const setLastMainStreamConversationRequestTokens = (
  state: MainStreamFetchState,
  tokens: (string | undefined)[]
): MainStreamFetchState => ({
  ...state,
  lastMainStreamConversationRequestTokens: tokens,
});
